import { DotsLoader } from "@similarweb/ui-components";

import { StyledDotsLoaderContainer } from "./styles";

type Props = {
    className?: string;
};

export const SignalsLoader = ({ className }: Props) => {
    return (
        <StyledDotsLoaderContainer
            className={className}
            role="progressbar"
            data-automation="loading-progress-bar"
        >
            <DotsLoader />
        </StyledDotsLoaderContainer>
    );
};
